import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import COLORS from '@/constants/colors';
import { CartResponse } from '@/data/api/model/cart/CartDto';
import { formatDollarAmount } from '@/utils/amounts';
import { formatDate } from '@/utils/dateTime';
import { CartItemUi } from './CartUi';

export const cartResponseToCartItemUi = (input: CartResponse): CartItemUi => {
  return {
    cartNumber: input.cart_number,
    cartId: input.cart_id,
    buyer: input.buyer_name,
    kam: input.admin_name,
    dateUpdate: formatDate(input.created_at, { time: true }),
    badgeStatus: cartStatusToStatusBadgeUi(input.cart_status),
    totalAmount: formatDollarAmount(input.total_amount),
  };
};

const cartStatusToStatusBadgeUi = (
  status: string
): statusBadgeUi | undefined => {
  switch (status) {
    case 'draft':
      return {
        statusId: status,
        textColor: COLORS.yellow_700,
        backgroundColor: COLORS.yellow_50,
        edgeColor: COLORS.yellow_200,
        text: 'Borrador',
      };
    case 'created':
      return {
        statusId: status,
        textColor: COLORS.success_700,
        backgroundColor: COLORS.success_50,
        edgeColor: COLORS.success_200,
        text: 'Creado',
      };
  }
};
